import React, { useState, useRef, useEffect } from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import Layout from "./timeline-layout";
import Axis from "./timeline-axis";
import CurrentIndicator from "./timeline-current-indicator";
import withStyles from "components/with-styles";
import styles from "./styles/timeline.css.js";
import DataGrid, { DataGridItem } from "components/data-grid";
import TimelineButtonAdd from "./timeline-button-add";

const Timeline = ({ displayOnly, type, period, elements, onSelectTime, onChange, classes }) => {
  const timelineRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [indicatorHeight, setIndicatorHeight] = useState(0);

  const handleSelectTime = time => {
    setCurrentTime(time);
    onSelectTime(time);
  };

  useEffect(
    () => {
      setIndicatorHeight(timelineRef && timelineRef.current ? timelineRef.current.offsetHeight : 0);
    },
    [elements.length],
  );

  return !elements ? null : (
    <DataGrid sizesOverride={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
      <DataGridItem big className={classes.timeline__container}>
        <div className={cn(classes.timeline__buttons, { [classes["timeline--preview"]]: displayOnly })}>
          {elements.map(element => (
            <TimelineButtonAdd
              key={element.layoutId}
              element={element}
              onChange={onChange}
              type={type}
              period={period}
            />
          ))}
        </div>
        <div className={classes.timeline}>
          <div className={classes.timeline__contents} ref={timelineRef}>
            {elements.map(element => (
              <Layout
                period={period}
                key={element.layoutId}
                element={element}
                onChange={onChange}
                type={type}
                displayOnly={displayOnly}
              />
            ))}
            <Axis period={period} onClick={handleSelectTime} />
            <CurrentIndicator period={period} currentTime={currentTime} height={indicatorHeight} />
          </div>
        </div>
      </DataGridItem>
    </DataGrid>
  );
};

Timeline.propTypes = {
  /**
   * Elementos del timeline (objetos custom con info del layout y del segment)
   */
  elements: PropTypes.arrayOf(
    PropTypes.shape({
      layoutId: PropTypes.string.isRequired,
      showAlways: PropTypes.bool.isRequired,
      name: PropTypes.string.isRequired,
      segments: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          start: PropTypes.number,
          end: PropTypes.number,
        }),
      ),
    }),
  ),
  /*
   * Callback que se llama con el elemento actualizado
   */
  onChange: PropTypes.func,
  /*
   * Callback que se llama con el tiempo seleccionado
   */
  onSelectTime: PropTypes.func,
  /**
   * Indica si está deshabilitada la edición o no
   */
  displayOnly: PropTypes.bool,
  /*
   * Período que representa el timeline (en segundos)
   */
  period: PropTypes.number,
  /*
   * Tipo de schedule
   */
  type: PropTypes.string,
};

export default withStyles(styles)(Timeline);
